import React from 'react';
import styles from './DeleteAccount.module.css';

const DeleteAccount: React.FC = () => {
	return (
		<div className={styles.container}>
			<h1 className={styles.header}>
				We're sad to see you go!
			</h1>
			<p className={styles.description}>
				Please reach out to <a href="mailto:inquiries@turtltracker.com">inquiries@turtltracker.com</a> for any specific feedback on where we could have done better!
			</p>
			<p className={styles.description}>
				To delete your account, please follow the in-app instructions below. Note that we still save your tracked turtles, but your user information (email, username, and related association to the tracked data) is deleted.
			</p>

			<h2 className={styles.subheader}>
				Step 1: Navigate to the Profile Page, Click on the elipse in the top right corner to go to the Edit Profile Page
			</h2>
			<img
				src="https://turtl-web-images.azureedge.net/website/1_prof_page.png"
				alt="Profile Page"
				className={styles.image}
			/>

			<h2 className={styles.subheader}>
				Step 2: Scroll to the bottom of the Edit Profile page, click delete
			</h2>
			<img
				src="https://turtl-web-images.azureedge.net/website/2_del_button.png"
				alt="Edit Profile Page"
				className={styles.image}
			/>

			<h2 className={styles.subheader}>
				Step 3: Click "Delete Account" to confirm you want to delete your account
			</h2>
			<img
				src="https://turtl-web-images.azureedge.net/website/3_confirm_del.png"
				alt="Confirm Delete"
				className={styles.image}
			/>

			<h2 className={styles.subheader}>
				Step 4: A confirmation window will appear on the welcome page that your account has been deleted
			</h2>
			<img
				src="https://turtl-web-images.azureedge.net/website/4_confirm_del.png"
				alt="Delete Confirmed"
				className={styles.image}
			/>
		</div>
	);
};

export default DeleteAccount;

